import dayjs from 'dayjs'
import flatPickr from 'vue-flatpickr-component'

import TransferHistoryTable from './TransferHistoryTable/TransferHistoryTable.vue'

import { getTransferHistory, getActionMenu } from '@/api/action-defines/systemLog'
import { getInfoUser } from '@/api/action-defines/site-management'

import { ACTION_LOG_STATUS } from '@/@core/data/enum/actionLogStatus'
import { ACTION_EINVOICE_LOG_STATUS } from '@/@core/data/enum/actionEInvoiceLog'
import { ACTION_ENUM } from '@/@core/data/enum/actionCodeMap'

export default {
  name: 'TransferHistory',
  components: {
    flatPickr,
    TransferHistoryTable,
  },

  data() {
    return {
      // enums (UI)
      logStatus: { ...ACTION_LOG_STATUS },
      logEinvoiceStatus: { ...ACTION_EINVOICE_LOG_STATUS },

      // date range picker
      dateRange: null,
      dateRangeConfig: {
        mode: 'range',
        locale: { rangeSeparator: ' -> ' },
        enableTime: true,
        time_24hr: true,
        dateFormat: 'd/m/Y H:i',
      },

      // search
      searchData: {
        FromDate: null,
        ToDate: null,
        KeyWord: null,
      },

      // table data
      logData: [],

      // pagination (server paging – giống SiteManagement)
      paging: {
        PageSize: 20,
        PageIndex: 1,
      },
      totalPagination: {
        TotalRecord: 0,
        TotalPage: 0,
      },

      // UI state
      buttonDisabled: 'collapse',
      loading: false,
    }
  },

  async created() {

    // default range: now -> end of today (giữ logic bạn đang dùng)
    const now = dayjs()
    const endOfToday = dayjs().endOf('day')

    const formattedNow = now.format('DD/MM/YYYY HH:mm')
    const formattedEnd = endOfToday.format('DD/MM/YYYY HH:mm')

    this.dateRange = `${formattedNow} -> ${formattedEnd}`
    this.searchData.FromDate = now.toISOString()
    this.searchData.ToDate = endOfToday.toISOString()

    await this.getRows()
  },

  methods: {
    // ========== Main fetch (giống getListSite) ==========
    setSearchDate() {
      if (!this.dateRange || typeof this.dateRange !== 'string') return

      const parts = this.dateRange.split('->')
      if (!parts[0] || !parts[1]) return

      const fromText = parts[0].trim()
      const toText = parts[1].trim()

      // backend thường ăn ISO / hoặc format chuẩn
      const from = dayjs(fromText, 'DD/MM/YYYY HH:mm')
      const to = dayjs(toText, 'DD/MM/YYYY HH:mm')

      if (!from.isValid() || !to.isValid()) return

      this.searchData.FromDate = from.toISOString()
      this.searchData.ToDate = to.toISOString()
    },

async getRows() {
  this.setSearchDate()

 const BodyData = {
  ...this.searchData,
  KeyWord: this.searchData.KeyWord?.trim() || null,
  PageIndex: this.paging.PageIndex - 1, 
  PageSize: this.paging.PageSize,
}

  this.loading = true
  try {
    const res = await getTransferHistory({ BodyData })

    if (res?.StatusCode === '200') {
      const data = res.Data || {}
      const rows = Array.isArray(data.Items) ? data.Items : []

      // gắn trạng thái collapse mặc định
      this.logData = rows.map(r => ({
        ...r,
        isCollapsed: true,
      }))

      // gán pagination
      this.totalPagination.TotalRecord = data.TotalRecords ?? 0
      this.totalPagination.TotalPage = data.TotalPages ?? 0

      this.buttonDisabled = 'collapse'
    } else {
      this.logData = []
      this.totalPagination = { TotalRecord: 0, TotalPage: 0 }
    }
  } catch (err) {
    console.error('getRows error:', err)
    this.logData = []
    this.totalPagination = { TotalRecord: 0, TotalPage: 0 }
  } finally {
    this.loading = false
  }
},

    // ========== events (giống SiteManagement) ==========
    async changePage(paging) {
      this.paging = paging
      await this.getRows()
    },

    searchTransferHistory() {
      this.paging.PageIndex = 1
      this.getRows()
    },

    onCreatedByChange() {
      this.paging.PageIndex = 1
      this.getRows()
    },

    // ========== expand/collapse ==========
    collapseAll() {
      this.logData = this.logData.map(log => ({ ...log, isCollapsed: true }))
      this.buttonDisabled = 'collapse'
    },

    expandAll() {
      this.logData = this.logData.map(log => ({ ...log, isCollapsed: false }))
      this.buttonDisabled = 'expand'
    },

    toggleCollapseLogRow(log) {
      log.isCollapsed = !log.isCollapsed
    },
  },
}
